import script from "./PersonalDataView.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalDataView.vue?vue&type=script&setup=true&lang=js"

import "./PersonalDataView.vue?vue&type=style&index=0&id=33f4f222&lang=scss"

const __exports__ = script;

export default __exports__